import type FavoriteNodeViewState from './schema/FavoriteNodeViewState';
import type FavoritesViewState from './schema/FavoritesViewState';
import type MailFavoritesStore from './schema/MailFavoritesStore';
import { createStore } from 'owa-satcheljs';
import type { AccountKey } from 'owa-client-types';

const defaultMailFavoritesStore: MailFavoritesStore = {
    mailFavoritesViewState: new Map<AccountKey, FavoritesViewState>([]),
    isFavoritingInProgress: new Map<string, boolean>([]),
    favoriteNodeViewStates: new Map<string, FavoriteNodeViewState>([]),
};

export const getStore: () => MailFavoritesStore = createStore<MailFavoritesStore>(
    'mailFavorites',
    defaultMailFavoritesStore
);
